"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gs_1 = require("@ivanlog/gs");
const tmplsInj_1 = require("../classes/com/tmplsInj");
const config_1 = require("./config");
const AppPM_1 = require("./AppPM");
// let lang = localStorage.getItem('lang');
// if (!lang) {localStorage.setItem('lang','en'); lang='en';}
// gs.localization.setLang(lang);
gs_1.FormGS.TagClassName = 'form';
gs_1.WrapperGS.ExtendComponentsByTagClass(gs_1.FormGS);
(0, tmplsInj_1.InjectComponents)();
//const swipe = new CmpPhotoSwipe();
//gs.w(document.querySelector('body')).append(swipe);
(0, config_1.ConfigApp)();
globalThis.app = new AppPM_1.AppPM();
//# sourceMappingURL=index.js.map